export default "__VITE_ASSET__DPm$8R_8__"